import React, { createContext, useEffect, useReducer, useState } from "react";
import AuthReducer from "./AuthReducer";
import { _deleteData, _retrieveData, _storeData } from "../../utils/local-storage";
import { Link, useLocation, useHistory } from "react-router-dom";
import { authGetRequest } from "../../api/laravel/public/api";


const getUserData = async () => {
  try {
    const jsonValue = await _retrieveData("user_info");
    return jsonValue ? jsonValue : null;
  } catch (e) {
    // alert(JSON.stringify(e))
  }
};

const getUserToken = async () => {
  try {
    const jsonValue = await _retrieveData("user_token");
    return jsonValue ? jsonValue : null;
  } catch (e) {
    // alert(JSON.stringify(e))
    // error reading value
  }
};
const INITIAL_STATE = {
  user: getUserData() || null,
  token:getUserToken()||null,
  isFetching: false,
  error: false,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  // const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const router = useHistory();

  useEffect(() => {
    saveData();
    saveToken();
  }, [token]);

  const saveData = async () => {
    const jsonValue = await _retrieveData("user_info");
    setUser(jsonValue ? jsonValue : null);
  };

  const saveToken = async () => {
    const jsonValue = await _retrieveData("user_token");
    setToken(jsonValue ? jsonValue : null);
  };

  const changeAuthUser = async (user) => {
    setUser(user);
    const jsonValue = await _storeData(user, "user_info");
  };

  const changeToken = async (token) => {
    setToken(token);
    const jsonValue = await _storeData(token, "user_token");
  };

  const logOut = async () => {
    setToken(null);
    setUser(null);
    await _deleteData("user_info");
    await _deleteData("user_token");
    window.sessionStorage.clear()
    router.push('/auth/login');
  };

  // const checkUser = async () => {
  //   let storeUser = await _retrieveData('user_info');
  //   if (storeUser) {
  //     setUser(storeUser);
  //   }
  //   const { data_r, isLoading, isError, message } = await authGetRequest("/account/profile");
  //   if (message === "Unauthenticated.") {
  //     // alert(JSON.stringify(storeUser));
  //   }
  //   else {
  //     await _storeData(data_r, 'user_info');
  //     setUser(data_r);
      
  //   }
  // }

  return (
    <AuthContext.Provider
      value={{
        user: user,
        token: token,
        changeAuthUser,
        changeToken,
        logOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
